import type {NavigationGuard} from 'vue-router'
import {useAuthStore} from '@/stores/auth'
import {isL2User} from '@/composables/useL2Identity'

export const guestGuard: NavigationGuard = () => {
  const authStore = useAuthStore()

  if (authStore.isAuth) {
    if (authStore.userPermissions.size === 0) {
      return '/no-access'
    }
    // L2-юзер сразу попадает на свой первый экран
    if (isL2User()) {
      return '/l2/organizations'
    }
    return '/users'
  }
}
